// extracted by mini-css-extract-plugin
export var activeDot = "_99-c";
export var buttonContainer = "_99-9";
export var channelButton = "_99-a";
export var clickable = "_99-d";
export var content = "_99-0";
export var contentFull = "_99-2";
export var contentThird = "_99-1";
export var contentWrapper = "_99-7";
export var description = "_99-5";
export var heightShort = "_99-f";
export var image = "_99-3";
export var imageContainer = "_99-4";
export var selectButton = "_99-e";
export var spinnerContainer = "_99-b";
export var titleContent = "_99-8";
export var titleWrapper = "_99-6";